import React from 'react'

class TabSet extends React.Component {

    renderChildren(children){
        return React.Children.map(children, child => {
            return React.cloneElement(child, {
                switch: this.props.switch
            });
        });
    }

    render () {
        return (
            <div {...this.props} className={['component-tabset', this.props.className].join(' ')}>
                { this.renderChildren(this.props.children) }
            </div>
        )
    }
}

export default TabSet;



// WEBPACK FOOTER //
// ./web-app/components/tab-set.jsx